module.exports = __webpack_public_path__ + "img/logo_animod2x.c7e1b492.png";